import React from 'react';
import { getExperienceData } from '../data/experienceData.js';
import { getEducationData } from '../data/educationData.js';
import { getSkillsData } from '../data/skillsData';
import ExperienceCard from './ExperienceCard.js';
import { useTranslation } from 'react-i18next';

function Experience() {
  const { t } = useTranslation();
  
  const experienceData = getExperienceData(t);
  const educationData = getEducationData(t);
  const skillsData = getSkillsData(t);
  const SkillCard = ({ category }) => (
    <div className='bg-white dark:bg-[#2a3038] rounded-lg p-4 sm:p-5 md:p-6 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1'>
      <div className='flex items-center mb-3 sm:mb-4'>
        <span className='text-2xl sm:text-3xl mr-2 sm:mr-3'>{category.icon}</span>
        <h3 className='text-base sm:text-lg font-semibold text-[#ec6e59]'>{category.title}</h3>
      </div>
      <div className='flex flex-wrap gap-1.5 sm:gap-2'>
        {category.skills.map((skill, index) => (
          <span
            key={index}
            className='px-2.5 sm:px-3 py-1 sm:py-1.5 bg-gray-100 dark:bg-[#20262E] text-xs sm:text-sm rounded-full text-gray-700 dark:text-gray-300 hover:bg-[#ec6e59] hover:text-white transition-colors duration-200 cursor-default'
          >
            {skill}
          </span>
        ))}
      </div>
    </div>
  );

  return (
    <div id="experience" className='mx-4 sm:mx-6 md:mx-8 lg:mx-10 my-6 sm:my-8 md:my-10 px-2 sm:px-4 md:px-6 py-4 sm:py-6'>
      <div className='flex flex-col lg:flex-row gap-10 sm:gap-12 lg:gap-0'>
        
        {/* Left Column: Experience & Education */}
        <div className='w-full lg:w-3/5 lg:pr-8'>
          {/* Experience Section */}
          <div className='mb-6 sm:mb-8 lg:mb-16'>
            <div>
              <h1 className='mb-4 sm:mb-6 md:mb-8 tracking-wide sm:tracking-wider font-semibold text-xl sm:text-2xl md:text-3xl lg:text-3xl'>
                {t('experience.title')}
              </h1>
            </div>
            {experienceData.map((exp) => {
              return (
                <ExperienceCard
                  key={exp.id}
                  {...exp}
                />
              )
            })}
          </div>

          {/* Education Section */}
          <div id="education">
            <div>
              <h1 className='mb-4 sm:mb-6 md:mb-8 tracking-wide sm:tracking-wider font-semibold text-xl sm:text-2xl md:text-3xl lg:text-3xl'>
                {t('experience.education')}
              </h1>
            </div>
            {educationData.map((exp) => {
              return (
                <ExperienceCard
                  key={exp.id}
                  {...exp}
                />
              )
            })}
          </div>
        </div>

        {/* Right Column: Skills */}
        <div className='w-full lg:w-2/5 lg:pl-8 lg:border-l-2 border-gray-200 dark:border-gray-700'>
          <div>
            <h1 className='mb-4 sm:mb-6 md:mb-8 tracking-wide sm:tracking-wider font-semibold text-xl sm:text-2xl md:text-3xl lg:text-3xl'>
              {t('experience.skills')}
            </h1>
            <p className='text-gray-600 dark:text-gray-400 mb-4 sm:mb-6 text-sm sm:text-base leading-relaxed'>
              {t('experience.skillsDesc')}
            </p>
          </div>

          <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 gap-3 sm:gap-4'>
            {Object.values(skillsData).map((category, index) => (
              <SkillCard key={index} category={category} />
            ))}
          </div>
        </div>

      </div>
    </div>
  );
}

export default Experience;
 